import { RouterProvider } from 'react-router-dom';

// project import
import router from './routes';
import ThemeCustomization from './themes';

import ScrollTop from './components/ScrollTop';
import GlobalProvider from './providers/global'
import { AuthProvider } from "./providers/auth"
import './i18n';
// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <ScrollTop>
        <AuthProvider>
          <GlobalProvider>
            <RouterProvider router={router} />
          </GlobalProvider>
        </AuthProvider>
      </ScrollTop>
    </ThemeCustomization>
  );
}
